<template>
  <div class="lg:mt-0 relative w-full flex justify-center lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 h-96 lg:h-full">
    <img class="h-96 lg:h-auto xl:max-w-xl lg:absolute lg:inset-0  xl:w-4/5 object-cover bottom-0" src="@/assets/images/ilustraciones/ilustraciones_rapido.svg" alt="Woman on her phone" data-aos="zoom-in-right"/>
    <br><br>
  </div>
</template>
